/*
* @Author: lhl
* @Date:   2018-05-21 15:20:47
* @Last Modified by:   lhl
* @Last Modified time: 2018-05-21 15:21:35
*/

'use strict';

// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
    message: {
        title: '运动品牌'
    },
    placeholder: {
        enter: '请输入您喜欢的品牌'
    },
    brands: {
        nike: '耐克',
        adi: '阿迪达斯',
        nb: '新百伦',
        ln: '李宁'
    }
}


// WEBPACK FOOTER //
// ./src/lang/zh.js